import React from 'react';
import { Field } from '../../../shared/Field';
import type { HelloWorldValues } from '../schema';

/**
 * Step 1 — name capture.
 *
 * Uses the `Field` wrapper from `src/shared/Field.tsx` which wires the
 * design-system `TextField` to react-hook-form automatically. Validation
 * errors are surfaced inline by the design-system component — no manual
 * error span needed.
 */
export const Step1: React.FC = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 480 }}>
    <Field<HelloWorldValues> name="firstName" label="First name" placeholder="e.g. Jane" />
    <Field<HelloWorldValues> name="lastName" label="Last name" placeholder="e.g. Smith" />
  </div>
);
